import {
	LogsIcon,
	WarningIcon,
	File,
	UserIcon,
	apiKeyIcon,
	SettingsIcon,
	PromptsIcon,
	ManagementIcon,
	AccessIcon,
	ReportsIcon
} from "../../app/components/IconsSVG";
import store from "../../app/store/store";

export const MenuConfig = () => {
	const { auth } = store.getState();
	const userRole = auth.user?.role;
	const menu = {
		header: {
			self: {},
			items: []
		},
		aside: {
			self: {},
			items: []
		}
	};

	let userMenu = [
		{
			title: "Prompts",
			root: true,
			icon: PromptsIcon,
			bullet: "dot",
			submenu: [
				{
					title: "Projetos",
					root: true,
					icon: LogsIcon,
					bullet: "dot",
					page: "/dashboard/projects"
				},
				{
					title: "Falhos",
					root: true,
					icon: WarningIcon,
					bullet: "dot",
					page: "/dashboard/fails"
				}
			]
		}
	];

	if (userRole === "MANAGER" || userRole === "ADMIN") {
		userMenu[0].submenu.push({
			title: "Presets de Áudio",
			root: true,
			icon: SettingsIcon,
			bullet: "dot",
			page: "/dashboard/presets"
		});
	}

	let managerMenu = [];

	let adminMenu = [
		{
			title: "Relatórios",
			root: true,
			icon: ReportsIcon,
			bullet: "dot",
			page: "/dashboard/costs"
		},
		{
			title: "Acesso",
			root: true,
			icon: AccessIcon,
			bullet: "dot",
			submenu: [
				{
					title: "Usuários",
					root: true,
					icon: UserIcon,
					bullet: "dot",
					page: "/dashboard/users"
				},
				{
					title: "Api Keys",
					root: true,
					icon: apiKeyIcon,
					bullet: "dot",
					page: "/dashboard/apikeys"
				}
			]
		},
		{
			title: "Gerenciamento",
			root: true,
			icon: ManagementIcon,
			bullet: "dot",
			submenu: [
				{
					title: "Provedores de TTS",
					root: true,
					icon: File,
					bullet: "dot",
					page: "/dashboard/providers"
				},
				{
					title: "Modelos de voz",
					root: true,
					icon: File,
					bullet: "dot",
					page: "/dashboard/models"
				},
				{
					title: "Configurações",
					root: true,
					icon: SettingsIcon,
					bullet: "dot",
					page: "/dashboard/settings"
				}
			]
		}
	];

	if (auth.user?.role === "USER") menu.aside.items = [...userMenu];

	if (auth.user?.role === "MANAGER")
		menu.aside.items = [...userMenu, ...managerMenu];

	if (auth.user?.role === "ADMIN")
		menu.aside.items = [...userMenu, ...adminMenu, ...managerMenu];

	return menu;
};

export default MenuConfig;
